import { axiosPrivate } from "../api/axios";

const useAxiosPrivate = () => axiosPrivate;

export default useAxiosPrivate;
